import Service, { inject as service } from '@ember/service';

export default Service.extend({
  api: service(),

  /**
   * @param {String} userId
   * @return {Ember.RSVP.Promise}
   */
  getHyperwalletUser(userId) {
    const endpoint = `/users/${userId}/hyperwallet-user`;
    const options = {};

    return this.get('api').request(endpoint, options);
  },

  /**
   * @param {String} userId
   * @param {Object} jsonData
   * @param {String} jsonData.firstName
   * @param {String} jsonData.lastName
   * @param {String} jsonData.dateOfBirth
   * @param {String} jsonData.addressLine1
   * @param {String} jsonData.addressLine2
   * @param {String} jsonData.city
   * @param {String} jsonData.stateProvince
   * @param {String} jsonData.country
   * @param {String} jsonData.postalCode
   * @param {String} jsonData.profileType
   * @return {Ember.RSVP.Promise}
   */
  createHyperwalletUser(userId, jsonData) {
    const endpoint = `/users/${userId}/hyperwallet-user`;
    const options = { jsonData };

    return this.get('api').post(endpoint, options);
  },

  /**
   * @param {String} userId
   * @param {Object} jsonData
   * @param {String} [jsonData.firstName]
   * @param {String} [jsonData.lastName]
   * @param {String} [jsonData.dateOfBirth]
   * @param {String} [jsonData.addressLine1]
   * @param {String} [jsonData.addressLine2]
   * @param {String} [jsonData.city]
   * @param {String} [jsonData.stateProvince]
   * @param {String} [jsonData.country]
   * @param {String} [jsonData.postalCode]
   * @param {String} [jsonData.profileType]
   * @return {Ember.RSVP.Promise}
   */
  updateHyperwalletUser(userId, jsonData) {
    const endpoint = `/users/${userId}/hyperwallet-user`;
    const options = { jsonData };

    return this.get('api').put(endpoint, options);
  },
});
